export const getCssVariable = (variableName: string, defaultColor: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim() || defaultColor;
};
